// extracted by mini-css-extract-plugin
module.exports = {"Audio3DPlayer":"_10e3d","audio3DPlayer":"_10e3d","first":"_3XxnA","second":"_1Yfl6","gradient":"ouWEY","icon":"_2I22w","mediaButton":"_31BYH","pausing":"_3dXHE","playing":"_1ivCF"};